import React, { useEffect, useState } from 'react'
import DrawerWithTitleAndFooter from '../../../components/drawer/DrawerWithTitleAndFooter'
import Icons from '../../../components/icons/Icons'
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import { setShowChangePlan, setShowManageCardDrawer, setShowProfileDrawer } from "../DashboardSlice";
import { useDispatch, useSelector } from 'react-redux';
import styles from "./ProfileDrawer.styles"
import { componentKey as AuthenticationComponentKey } from "../../authentication/AuthenticationSlice"
import { componentKey as DashboardComponentKey } from "../DashboardSlice";
import { USER_TYPE } from '../../../../libs/customhooks/constants';
import { useUserTypeInfo } from '../../../../libs/customhooks/useUserTypeInfo';
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator';
import { logoutUser } from '../../authentication/AuthenticationSaga';
import Platform from '../../../../libs/utility/Platform';
import General from '../../../../libs/utility/General';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function ProfileDrawer({ onCloseCB }) {
	const navigate = useTxNavigate();
	const dispatch = useDispatch();
	const [showOnlyLogout, setShowOnlyLogout] = useState(false);
	const { signedInUser } = useSelector((state) => state[AuthenticationComponentKey])
	const { onboardingPending, errorInProfile } = useSelector((state) => state[DashboardComponentKey])

	const getUserName = () => {
		return `${signedInUser.FirstName} ${signedInUser.MiddleName !== '' ? `${signedInUser.MiddleName} ` : ''} ${signedInUser.LastName}`;
	}

	const { userType } = useUserTypeInfo();

	useEffect(() => {
		if(errorInProfile || onboardingPending){
			setShowOnlyLogout(true);
		}
	}, [errorInProfile, onboardingPending])

	let MenuOptions = [
		{
			IconName: VEC_ICON_NAME.GENERAL_ICON,
			Text: 'General Settings',
			onClick: () => { 
				handleClose();
				navigate("/account/general");
			},
			AllowRole: [],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.UPGRADE_PLAN_ICON,
			Text: 'Upgrade Plan',
			onClick: () => { 
				handleClose();
				dispatch(setShowChangePlan(true))
			},
			AllowRole: [USER_TYPE.EFILE_PLUS_USER, USER_TYPE.ESSENTIAL_USER],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.CHANGE_PASSWORD_ICON,
			Text: 'Change Password',
			onClick: () => {
				handleClose();
				navigate("/account/changepassword");
			},
			AllowRole: [],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.TWO_FA_ICON,
			Text: '2 Factor Authentication',
			onClick: () => {
				handleClose();
				navigate("/account/twofactorauthentication");
			},
			AllowRole: [],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.ACTIVITY_LOG_ICON,
			Text: 'Activity Logs',
			onClick: () => {
				handleClose();
				navigate("/account/activitylogs");
			},
			AllowRole: [],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.HELP_SUPPORT_ICON,
			Text: 'Help & Support',
			onClick: () => { 
				handleClose();
				navigate("/support"); 
			},
			AllowRole: [],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.MANAGE_CARDS_VECTOR,
			Text: 'Manage Cards',
			onClick: () => { 
				dispatch(setShowManageCardDrawer(true))
				handleClose();
			},
			AllowRole: [],
			AllowOnboardingPending: false,
		},
		{
			IconName: VEC_ICON_NAME.LOGOUT_ICON,
			Text: 'Logout',
			onClick: () => { 
				handleClose();
				dispatch(logoutUser())
			},
			AllowRole: [],
			AllowOnboardingPending: true,
		},
	]

	const handleClose = () => {
		dispatch(setShowProfileDrawer(false));
	};
	const navigateToProfileEdit = () => {
		navigate("/account/editprofile");
		handleClose();
	};

	if(showOnlyLogout) {
		MenuOptions = MenuOptions.filter(options => options.AllowOnboardingPending)
	}

	return (
		<DrawerWithTitleAndFooter isOpen={true} onCloseCb={handleClose} title={""} customStylesDrawer={{width: Platform.isMobileView() ? "100%" : "350px", }}>
			<div>
				<div style={styles.drawerMenuMainContainer}>
					<div style={styles.drawerUserInfoContainer}>
						<div style={styles.drawerUserNameContainer}>
							<span style={styles.drawerUserNameText}>{getUserName()}</span>
							{ !showOnlyLogout && 
								<div
									onClick={navigateToProfileEdit}
									style={styles.drawerUserEditIcon}
								>
									<Icons
										familyName={"vec"}
										iconName={VEC_ICON_NAME.PROFILE_EDIT_ICON}
									/>
								</div>
							}
						</div>
						<span style={styles.drawerUserTypeText}>{userType}</span>
					</div>
					<HorizontalSeparator />
					{MenuOptions.map((option) => 

						( General.hasAccessToUserType(userType, option.AllowRole) ? 
							<div
								style={styles.drawerMenuItemContainer}
								onClick={option.onClick}
							>
								<Icons
									familyName={"vec"}
									iconName={option.IconName}
								/>
								<span>{option.Text}</span>
							</div>
							:
							<></>
						)
					)}
				</div>
			</div>
		</DrawerWithTitleAndFooter>
	);
}